export const EMPTY_PATH = "";
export const SLASH_PATH = "/";
export const HASH_PATH = "#";

export const EMPLOYEE_DIRECTORY_PATH = "/team/employee-directory";
export const COMPANY_STRUCTURE_PATH = "/team/company-structure";
export const EMPLOYEE_CLUB_PATH = "/team/employee-club";
export const IMPORT_PEOPLE_PATH = "/team/import-people";
export const RECRUITMENT_PATH = "/team/recruitment";
export const MY_TIME_PATH = "/time/my-time-off";
export const EMPLOYEE_TIME_OFF_PATH = "/time/employee-time-off";
export const TIME_OFF_CALENDAR_PATH = "/time/time-off-calendar";
export const TIME_OFF_REQUEST_PATH = "/time/time-off-request";
export const POLICY_BALANCE_PATH = "/time/policy-balance";
export const IMPORT_TIME_OFF_PATH = "/time/import-time-off";
export const MY_ATTENDANCE_PATH = "/time/my-attendance";
export const EMPLOYEE_ATTENDANCE_PATH = "/time/employee-attendance";
export const SURVAY_PATH = "/growth/survey";
export const MY_EVALUATION_PATH = "/growth/my-evaluation";
export const TEAM_EVALUATION_PATH = "/growth/team-evaluation";
export const EMPLOYEE_EVALUATION_PATH = "/growth/employee-evaluation";
export const MY_GOALS_PATH = "/growth/my-goals";
export const TEAM_GOALS_PATH = "/growth/team-goals";
export const EMPLOYEE_GOALS_PATH = "/growth/employee-goals";
export const ONE_ON_ONE_PATH = "/growth/1-on-1s";
export const MY_FILES_PATH = "/files/my-files";
export const EMPLOYEE_FILES_PATH = "/files/employee-files";
export const COMPANY_FILES_PATH = "/files/company-files";
export const CONFIDENTIAL_FILES_PATH = "/files/confidential-files";
export const E_SIGN_PATH = "/files/e-sign-files";
export const MY_TASKS_PATH = "/tasks/my-tasks";
export const EMPLOYEE_TASKS_PATH = "/tasks/employee-tasks";
export const MANAGE_TASKS_PATH = "/tasks/manage-tasks";
export const MY_BENEFITS_PATH = "/benefits/my-benefits";
export const BENEFITS_DETAILS_PATH = "/benefits/benefit-details";
export const BENEFITS_REQUESTS_PATH = "/benefits/benefit-requests";
export const ANALYTICS_DASHBOARD_PATH = "/analysis/analytics-dashboard";
export const REPORTS_PATH = "/analysis/reports";
export const PAYROLL_ANALYTICS_PATH = "/payroll/payroll-analytics";
export const COMPANY_PAYROLL_PATH = "/payroll/company-payroll";
export const EMPLOYEE_PAYROLL_PATH = "/payroll/employee-payroll";
export const MY_COMPANY_PATH = "/settings/my-company";
export const LOCATIONS_PATH = "/settings/locations";
export const DEPARTMENTS_PATH = "/settings/departments";
export const CALENDAR_PATH = "/settings/calendars";
export const FLOWS_PATH = "/settings/flows";
export const TIME_OFF_PATH = "/settings/time-off";
export const ATTENDANCE_PATH = "/settings/attendance";
export const PERFORMANCE_PATH = "/settings/performance";
export const FILES_PATH = "/settings/files";
export const TASKS_PATH = "/settings/tasks";
export const BENEFITS_PATH = "/settings/benefits";
export const PAYROLL_PATH = "/settings/payroll";
export const ROLES_AND_PERMISSIONS_PATH = "/settings/role-&-permissions";
export const INTEGRATION_PATH = "/settings/integrations";
export const PERSONALISATION_PATH = "/settings/personalisation";
export const PROFILE_PATH = "/profile";
export const LOGOUT_PATH = "/logout"